import { cx } from './cx';

export interface CountBadgeProps {
  count: number;
  max?: number;
  /** Screen-reader text, e.g. "3 unread tickets" (already translated). */
  label?: string;
  className?: string;
}

/** Small numeric badge for unread counts; renders nothing at zero. */
export default function CountBadge({ count, max = 99, label, className }: CountBadgeProps) {
  if (!count || count <= 0) return null;
  return (
    <span
      className={cx(
        'inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-action-primary px-1.5 font-ui text-small font-semibold leading-none text-white tabular-nums',
        className
      )}
    >
      <span aria-hidden={label ? true : undefined}>{count > max ? `${max}+` : String(count)}</span>
      {label ? <span className="sr-only">{label}</span> : null}
    </span>
  );
}
